export function IntroBg(){
    return (
        <div className="origin-story-bg">
            <div className="bg">
                <div className="container">
                    <div className="our-story-title">
                        <h1>Built from a passion to remove barriers to human connection</h1>
                    </div>
                </div>
            </div>
        </div>
    )
}